import { InputLabel } from "@mui/material";
import styled from "styled-components";

export const MyInputLable = styled(InputLabel)`
  && {
    font-size: 12px;
  }
`;
